import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { NavigationModule } from '../navigation/navigation.module';
import { RouterModule } from '@angular/router';
import { NavigationItemModule } from '../../components/navigation-item/navigation-item.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../app/shared/shared.module';
import { ToolbarUserModule } from './toolbar-user/toolbar-user.module';
import { ToolbarNotificationsModule } from './toolbar-notifications/toolbar-notifications.module';

@NgModule({
  declarations: [ToolbarComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatRippleModule,
    ReactiveFormsModule,
    NavigationModule,
    RouterModule,
    NavigationItemModule,
    TranslateModule,
    SharedModule,
    ToolbarUserModule,
    ToolbarNotificationsModule,
  ],
  exports: [ToolbarComponent],
})
export class ToolbarModule {}
